import lineIntersect from '@turf/line-intersect';
import toTurf from '../utils/toTurf.js';
import fromTurf from '../utils/fromTurf.js';
import GeoJSON from 'ol/format/GeoJSON';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import RegularShape from 'ol/style/RegularShape';

export default function getIntersectPointTurf(feat1, feat2, mapProjection) {
  const formatGeo = new GeoJSON();
  const turfFeat1 = toTurf(feat1, mapProjection, formatGeo);
  const turfFeat2 = toTurf(feat2, mapProjection, formatGeo);

  const intersection = lineIntersect(turfFeat2, turfFeat1);

  return intersection.features.map(f => {
    const olFeature = fromTurf(f, mapProjection, formatGeo);
    olFeature.setStyle(new Style({
      image: new RegularShape({
        fill: new Fill({ color: 'rgba(255, 255, 255, 0.5)' }),
        stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.9)', width: 2 }),
        points: 5,
        radius: 10,
        radius2: 4,
        angle: 0
      })
    }));
    return olFeature;
  });
};
